import { NavLink, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
var ArticleTitle = function ArticleTitle(_ref) {
  var title = _ref.title,
    breadcrumbs = _ref.breadcrumbs,
    subtitle = _ref.subtitle,
    slug = _ref.slug;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  if (!title || title.length === 0) return null;
  var style = {};
  if (!breadcrumbs || breadcrumbs.length === 0) style['marginTop'] = 30;
  if (!subtitle || subtitle.length === 0) style['marginBottom'] = 20;
  return /*#__PURE__*/React.createElement("div", {
    className: "a__title",
    style: style
  }, !articleID ? /*#__PURE__*/React.createElement(NavLink, {
    to: "".concat(pathname, "/").concat(slug)
  }, /*#__PURE__*/React.createElement("h2", null, title)) : /*#__PURE__*/React.createElement("h1", null, title));
};
export default ArticleTitle;